import { createContext } from "react";

export const AppContext = createContext({
  svgStore: undefined,
  setSvgStore: () => {},
  image64: undefined,
  setImage64: (base64) => {},
  referenceImage64: undefined,
  setReferenceImage64: (base64) => {},
  imagePrompt: undefined,
  setImagePrompt: (prompt) => {},
  imageSource: undefined,
  setImageSource: (source) => {},
  imageSEO: undefined,
  setImageSEO: (seo) => {},
  image64Resize: undefined,
  setImage64Resize: (base64) => {},
  fileName: undefined,
  setFileName: (name) => {},
  // Tutorial support
  tutorialMode: false,
  setTutorialMode: (enabled) => {},
  processTutorialImage: (imageData) => {},
  // Debug mode for UI testing
  debugEmptyState: false,
  setDebugEmptyState: (enabled) => {},
  // Set to true when the user enters the upload flow via the Embroidery
  // sidebar button. Read by SvgEditorDesktop so the editor opens directly
  // into Stitch mode after conversion. Cleared once consumed.
  pendingEmbroideryMode: false,
  setPendingEmbroideryMode: (enabled) => {},
});

export default AppContext;
